/**
 * Trial signup service for checking if trial signups are enabled.
 */

/**
 * Check if trial signup is enabled by reading the meta tag injected by the server.
 * Returns true if enabled, false if disabled.
 */
export function isTrialSignupEnabled(): boolean {
    const meta = document.head.querySelector('meta[name=bf-trial-signup-enabled]') as HTMLMetaElement;
    return meta?.content === 'true';
}

/**
 * Get the message to display when trial signup is disabled.
 * Returns the custom message from admin settings, or a default message if not set.
 */
export function getTrialSignupDisabledMessage(): string {
    const meta = document.head.querySelector('meta[name=bf-trial-signup-disabled-message]') as HTMLMetaElement;
    return meta?.content || 'Trial registration is currently unavailable. Please contact support@brainfocus.tech to request a trial.';
}
